var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18461)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00146484,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEC3DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6111,
    y: 20.9444,
    width: 12.6667,
    height: 3.22222,
    rx: 1.61111,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10487_18461)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.88962,
    y: 33.6513,
    width: 24.1111,
    height: 25.5556,
    rx: 12.0556,
    transform: "rotate(-16 4.88962 33.6513)",
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.389,
    y: 27.0556,
    width: 6.77778,
    height: 3.22222,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5557,
    y: 26.8889,
    width: 6.44444,
    height: 4.44444,
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8334,
    y: 12.5,
    width: 10.2222,
    height: 16.1111,
    rx: 5.11111,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17.6667H15.8889L15 19.7778V17.6667Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8889 17.6667H24L24.8889 19.7778V17.6667Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-1_10487_18461",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8739 31.2222C25.6553 32.9516 23.0842 34.3165 19.9445 34.3165C16.823 34.3165 14.2635 32.9674 14.0191 31.2522C9.83794 32.4497 6.77783 36.3009 6.77783 40.8669V48.4224H33.2223V40.8669C33.2223 36.262 30.1098 32.3842 25.8739 31.2222Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8739 31.2222C25.6553 32.9516 23.0842 34.3165 19.9445 34.3165C16.823 34.3165 14.2635 32.9674 14.0191 31.2522C9.83794 32.4497 6.77783 36.3009 6.77783 40.8669V48.4224H33.2223V40.8669C33.2223 36.262 30.1098 32.3842 25.8739 31.2222Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8739 31.2222L25.9621 30.9008L25.5914 30.7991L25.5432 31.1804L25.8739 31.2222ZM14.0191 31.2522L14.3491 31.2052L14.2952 30.8265L13.9274 30.9318L14.0191 31.2522ZM6.77783 48.4224H6.4445V48.7558H6.77783V48.4224ZM33.2223 48.4224V48.7558H33.5556V48.4224H33.2223ZM25.5432 31.1804C25.4536 31.8897 24.8676 32.5887 23.8498 33.1227C22.8425 33.6511 21.4696 33.9832 19.9445 33.9832V34.6498C21.5591 34.6498 23.0416 34.2995 24.1595 33.7131C25.2667 33.1322 26.0757 32.2842 26.2046 31.264L25.5432 31.1804ZM19.9445 33.9832C18.4283 33.9832 17.0624 33.6549 16.0567 33.1318C15.0405 32.6032 14.4495 31.9099 14.3491 31.2052L13.6891 31.2993C13.8331 32.3097 14.6441 33.1485 15.7491 33.7233C16.8646 34.3035 18.3392 34.6498 19.9445 34.6498V33.9832ZM7.11117 40.8669C7.11117 36.4536 10.0689 32.7303 14.1109 31.5727L13.9274 30.9318C9.60698 32.1691 6.4445 36.1483 6.4445 40.8669H7.11117ZM7.11117 48.4224V40.8669H6.4445V48.4224H7.11117ZM33.2223 48.0891H6.77783V48.7558H33.2223V48.0891ZM32.8889 40.8669V48.4224H33.5556V40.8669H32.8889ZM25.7857 31.5437C29.8806 32.6669 32.8889 36.416 32.8889 40.8669H33.5556C33.5556 36.1081 30.3391 32.1014 25.9621 30.9008L25.7857 31.5437Z",
    fill: "#111111",
    mask: "url(#path-10-inside-1_10487_18461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6344 14.2963L24.6412 14.3097L24.6502 14.3218C24.9413 14.7094 25.1264 14.9772 25.2601 15.2603C25.3928 15.5411 25.4785 15.8448 25.5581 16.3061L25.5577 16.3062L25.5607 16.3182C25.7215 16.9613 25.7224 17.7949 25.7224 18.2777C25.7224 18.6512 25.6192 22.1856 25.5752 23.6752C25.5616 24.1346 25.7657 24.5714 26.1248 24.8565H25.0705L25.0797 20.2163V20.216V19.832V19.5312L24.8247 19.6907C24.435 19.9344 24.1125 20.0782 23.7534 20.163C23.3922 20.2482 22.9858 20.2756 22.4234 20.2757C21.4854 20.2317 20.6512 19.6404 20.0708 18.8549C19.611 18.2326 18.9388 17.6914 18.119 17.6533L15.2858 17.5217C15.1314 17.5145 15.0008 17.6348 14.9953 17.7892L14.9345 19.4885L14.9345 19.4885L14.9345 19.4901L14.7909 24.9212H13.9948C13.9795 24.9212 13.9706 24.9168 13.9646 24.9122C13.9576 24.9068 13.9512 24.8982 13.9475 24.8869C13.9438 24.8757 13.9439 24.8649 13.9463 24.8564C13.9484 24.8492 13.953 24.8404 13.9653 24.8313C14.2726 24.6061 14.45 24.2445 14.44 23.8636L14.278 17.6841C14.3424 16.1093 14.9591 14.6665 16.1205 13.6005L16.1205 13.6005L16.1214 13.5996C16.592 13.1609 17.1254 12.8157 17.6907 12.5642L17.7623 12.5367C19.2074 11.9825 20.802 11.9585 22.263 12.4689C23.1676 12.8438 23.9814 13.4671 24.61 14.2475L24.6344 14.2963Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.333333
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.748535,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18461"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00146484,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10487_18461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.4444,
    height: 35.5556,
    fill: "white",
    transform: "translate(7.77783 2.66666)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric13);
export default __webpack_public_path__ + "static/media/Generic 13.28051bbc87998066dc6e00338bdc050f.svg";
export { ForwardRef as ReactComponent };